import { TextVariant } from "@/components/Typography/Text.variant";
import { textVariantClassMap } from "@/components/Typography/textVariantClassMap";
import { typedKeys, typedValues } from "@/utils/object-utils";
import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Text.tsx で定義されている TextVariant のキーを動的に取得する
const fontSizeKeys = typedKeys(TextVariant);

/**
 * tailwind-mergeにカスタムクラスと競合解決ルールを追加したもの
 * @see https://github.com/dcastil/tailwind-merge/blob/main/docs/configuration.md#customizing-configuration
 */
const customTwMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      // カスタムフォントサイズを `font-size` グループに追加し、`text-color` グループと競合しないように設定
      // @see https://github.com/dcastil/tailwind-merge/blob/main/docs/configuration.md#class-groups
      // @see https://github.com/dcastil/tailwind-merge/blob/v2.5.4/docs/configuration.md#usage-with-custom-tailwind-config
      "font-size": [...fontSizeKeys.map((key) => `text-${key}`)],
      w: [
        { "w-interaction-box": ["sm", "md", "lg", "xl"] },
        { "w-popover": ["sm", "md", "lg", "xl"] },
      ],
      "max-w": [{ "max-w-dialog": ["xs", "sm", "md", "lg", "xl"] }],
    },
  },
});

/**
 * clsxでクラス名を結合し、カスタム設定のtailwindMergeで競合を解決する
 * @param inputs クラス名の入力
 * @returns マージされたクラス名
 */
export function cn(...inputs: ClassValue[]) {
  const merged = clsx(inputs);

  // text-* クラスを正規表現で抽出し、TextVariant型のみに限定
  const matches = Array.from(merged.matchAll(/text-([a-zA-Z0-9]+)/g));
  const last = matches.length > 0 ? matches[matches.length - 1][1] : undefined;
  if (last && typedValues(TextVariant).includes(last as TextVariant)) {
    const extra = textVariantClassMap[last as TextVariant];
    return customTwMerge(merged, extra);
  }

  return customTwMerge(merged);
}
